import Nav from "./nav";
import Footer from "./footer";
import { useRouter } from "next/router";
import { useSession } from "@/components/providers/session";
import { useEffect, useState } from "react";
import FixedBanner from "./fixed-banner";
// import ElevenLabsConvaiWidget from "./elevenlabs-convai-widget";
import { trackOfflineSource } from "@/utils/track-offline-source";
import { GoogleBusinessProfileReviewStatsProvider } from "@/components/google-business-profile-review-stats-provider";

export default function Layout({
  siteData,
  children,
  allowStickyChildren = false,
  ...rest
}) {
  const router = useRouter();
  const session = useSession();
  const [selectedCoursesCount, setSelectedCoursesCount] = useState(
    session.selectedCourses ? session.selectedCourses.length : 0,
  );

  useEffect(() => {
    setTimeout(() => {
      setSelectedCoursesCount(
        session.selectedCourses ? session.selectedCourses.length : 0,
      );
    }, 1000);
  }, [session.selectedCourses.length]);

  useEffect(() => {
    // Leaving the online-course funnel exits focused mode: once a visitor
    // views any non-elearning page, restore the full site everywhere.
    if (!router.asPath.startsWith("/courses/elearning")) {
      try {
        sessionStorage.removeItem("cc.focus");
      } catch {
        // ignore
      }
    }
  }, [router.asPath]);

  useEffect(() => {
    if (!allowStickyChildren) {
      return;
    }

    document.documentElement.dataset.stickyLayout = "true";

    return () => {
      delete document.documentElement.dataset.stickyLayout;
    };
  }, [allowStickyChildren]);

  const pts = router.asPath.split("/").filter(Boolean);
  let promo = router.asPath === "/" || pts.length < 2;
  let online =
    router.asPath === "/courses/elearning/" ||
    router.asPath === "/courses/elearning";

  if (router.asPath.includes("/account")) {
    promo = false;
  }

  const phoneNumber = siteData?.fields?.phoneNumber;

  return (
    <GoogleBusinessProfileReviewStatsProvider stats={siteData?.googleReviewStats}>
      <>
        <FixedBanner router={router} />
      <div
        className={
          allowStickyChildren
            ? "relative flex min-h-screen flex-col overflow-x-clip bg-white"
            : "relative flex min-h-screen flex-col overflow-hidden bg-white"
        }
      >
        {siteData ? <Nav {...rest} siteData={siteData} /> : null}
        <p className="mt-0 text-white flex bg-brand-600 justify-center pt-2 pb-2 hover:text-gray-200 shadow overflow-hidden items-center">
          <svg className="size-4 block" viewBox="0 0 20 20" fill="currentColor">
            <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
          </svg>
          <span className="flex items-center text-sm">
            <a href="/aesthetic-career-accelerator/">
              <span className="text-sm block ml-2 underline">
                5 Day Aesthetic Career Accelerator{" "}
              </span>
            </a>
            {phoneNumber ? (
            <a
              href={`tel:+44${phoneNumber
                .replace(/^0+/, "")
                .replace(/\s/g, "")}`}
              onClick={() => trackOfflineSource("phone", "layout-banner")}
              className="flex"
            >
              <span className="hidden md:inline">{' '}- Speak to an Advisor</span>
              <span className="sr-only">Phone number</span>
              <span className="text-sm block ml-1 underline">
                {phoneNumber}
              </span>
            </a>
            ) : null}
          </span>
        </p>
        <div className="border-b border-gray-200 md:hidden">
          <div className="flex h-16 items-center justify-between w-full">
            <div className="block flex-1 self-stretch w-full">
              <div className="flex h-full space-x-6 justify-between w-full text-center">
                <a
                  href="/pathway-to-aesthetics/"
                  className="flex items-center text-sm font-bold text-gray-700 hover:text-gray-800 bg-clip-text bg-no-repeat text-transparent bg-gradient-to-r py-4 from-brand-500 via-violet-500 to-brand-500 [text-shadow:0_0_rgba(0,0,0,0.1)]"
                >
                  Pathway to Aesthetics: Level 3 to 7 Training
                </a>
              </div>
            </div>
          </div>
        </div>
        <main className="flex flex-col flex-1 w-full">{children}</main>
        {siteData ? <Footer siteData={siteData} /> : null}
        <div className="sr-only w-0 h-0 overflow-hidden">
          <a href="/courses/injectables/">
            Accredited Injectable Training Courses
          </a>
          <a href="/courses/cpd/">CPD Accredited Training Courses</a>
          <a href="/training-course-calendar/">Training Course Calendar</a>
          <a href="/about/">About Us</a>
          <a href="/location/">Our Location</a>
          <a href="/team/">Meet The Team</a>
          <a href="/courses/education/">Education Training Courses</a>
          <a href="/courses/masterclasses/">Masterclasses Training Courses</a>
          <a href="/courses/new/">New Courses</a>
        </div>
      </div>
      {/* <ElevenLabsConvaiWidget /> */}
      </>
    </GoogleBusinessProfileReviewStatsProvider>
  );
}
